import shibuya from "./shibuya.json";
import minato from "./minato.json";
import astar from "./astar.json";
import testbnb from "./testbnb.json";
import local from "./local.json";
import IACL from "./abis/ACL.json";
import IAddressProvider from "./abis/AddressProvider.json";
import ICCIPBridge from "./abis/CCIPBridge.json";
import IDappStakingManager from "./abis/DappStakingManager.json";
import IDASTR from "./abis/DASTR.json";
import IVault from "./abis/Vault.json";

export {
  IACL,
  IAddressProvider,
  ICCIPBridge,
  IDappStakingManager,
  IDASTR,
  IVault,
};

const deployKey = {
  ACL: "ACL",
  AddressProvider: "AddressProvider",
  DASTR: "DASTR",
  DappStakingManager: "DappStakingManager",
  Vault: "Vault",
  CCIPBridge: "CCIPBridge",
  CCIPWSTASTRWrapper: "CCIPWSTASTRWrapper",
};

function extractMatchingKeys<T extends Record<string, string>>(
  sourceObject: T,
  keyPatterns: Record<string, string>
): Record<string, string> {
  return Object.keys(keyPatterns).reduce((acc, pattern) => {
    const matchedKey = Object.keys(sourceObject).find((key) =>
      key.endsWith(`${pattern}`)
    );
    if (!matchedKey) {
      // console.log(`找不到匹配的模块 ${pattern}`);
      return acc;
    }
    acc[pattern] = sourceObject[matchedKey];
    return acc;
  }, {} as Record<string, string>);
}

export const shibuyaDeploy = extractMatchingKeys(shibuya, deployKey);
export const testbnbDeploy = extractMatchingKeys(testbnb, deployKey);
export const minatoDeploy = extractMatchingKeys(minato, deployKey);
export const localDeploy = extractMatchingKeys(local, deployKey);
export const astarDeploy = extractMatchingKeys(astar, deployKey);

// 导出配置
export const deployments = {
  L1: shibuyaDeploy,
  L2: minatoDeploy,
};

// 默认导出
export default deployments;
